<template>
  <div id="wrapper" class="wrapper haslayout">
    <WebPortalHeader />
    <!--************************************
                home Slider Start
        *************************************-->
    <section class="page-title-home">
      <div class="page-banner-img">
        <img
          alt="img"
          class="img-fluid"
          src="../../assets/images/classroom.png"
        />
      </div>
      <div class="content-outer">
        <div class="content-box justify-content-center">
          <div class="inner">
            <div class="text">
              <span id="site-name">
                Directorate General of Medical Education (DGME)
              </span>
              <h1 class="main_sec">Contents</h1>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--************************************
                home Slider End
        *************************************-->
    <!--************************************
                Main Start
        *************************************-->
    <main id="" class="webportal_home haslayout">
      <!--************************************
                DGME links Start
            *************************************-->
      <section class="st-shape-wrap">
        <div class="container-fluid">
          <div class="row">
            <div class="webportal-contant">
              <LeftSlider />
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class="row">
                  <div class="mid_contant">
                    <div
                      class="
                        col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12
                        mt-5
                      "
                    >
                      <div class="row" id="notice-board">
                        <div class="notice-board-bg">
                          <!-- {{getPortalPublicData.notice}} -->
                          <h2>NOTICE BOARD</h2>
                          <div id="notice-board-ticker">
                            <ul class="caption">
                              <li
                                v-for="(
                                  item, index
                                ) in getPortalPublicData.notice"
                                :key="index"
                              >
                                <!-- href="/notice-details" -->
                                <a @click="noticeMethod(item)">{{
                                  item.title
                                }}</a>
                              </li>
                            </ul>
                            <a
                              class="btn btn-light float-right mr-3"
                              @click="goToViewAllNotice"
                              title="all Notice"
                              >View All</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12">
                      <div class=" block">
                        <div class="row">
                          <div class="col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12">
                            <h2
                              class="bk-org titlee"
                              style="font-weight: 300; font-family: 'Roboto'"
                            >
                              Content
                            </h2>
                          </div>
                        </div>
                        <div class="row">
                          <div
                            class="col-lg-6 col-md-12 col-sm-12 col-12"
                            v-for="(
                              content, index
                            ) in getPortalPublicData.content"
                            :key="index"
                          >
                            <div class="news-block">
                              <div class="inner-box">
                                <div class="image">
                                  <div class="ytvid">
                                    <div
                                      class="
                                        embed-responsive embed-responsive-16by9
                                      "
                                    >
                                      <iframe
                                        frameborder="0"
                                        :src="`${baseURL2}/${content.content_url}`"
                                        sandbox
                                      ></iframe>
                                    </div>
                                  </div>
                                  <div class="overlay">
                                    <div class="link-btn">
                                      <!--    :href="`${baseURL2}/${content.content_url}`" -->
                                      <a @click="contentDetailsMethod(content)"
                                        ><i class="fas fa-arrow-right"></i
                                      ></a>
                                    </div>
                                  </div>
                                </div>
                                <div class="lower-content">
                                  <div class="text">
                                    <p>{{ content.title }}<strong></strong></p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <RightSlider />
            </div>
          </div>
        </div>
        <div class="st-shape2">
          <img src="../../assets/images/contact-shape1.svg" alt="shape2" />
        </div>
      </section>
      <!--************************************
                DGME links Start
            *************************************-->
    </main>
    <!--************************************
                Main End
        *************************************-->
    <WebPortalFooter />
  </div>
</template>

<script>
import WebPortalHeader from "../../components/webPortalLayout/WebPortalHeader.vue";
import LeftSlider from "../../components/webPortalLayout/LeftSlider";
import RightSlider from "../../components/webPortalLayout/RightSlider";
import WebPortalFooter from "../../components/webPortalLayout/WebPortalFooter";
import { baseURL2 } from "@/store/api.js";

export default {
  name: "webPortal",
  components: {
    WebPortalHeader,
    LeftSlider,
    RightSlider,
    WebPortalFooter,
  },
  data() {
    return {
      baseURL2: baseURL2,
    };
  },
  created(){
    this.$store.dispatch("callHeaderFooterPublicData");
  },
  computed: {
    getPortalPublicData() {
      return this.$store.getters.getPortalPublicData;
    },
  },
  methods: {
    noticeMethod(val) {
      this.$router.push(`/notice-details/${val.id}`);
    },
    contentDetailsMethod(item) {
      let self = this;
      this.$router.push(`/content-details/${item.id}`);
    },
    goToViewAllNotice() {
      this.$router.push("/all-notice-list");
    },
  },
};
</script>

<style scoped>
.row {
  display: block;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
</style>